import moment from 'moment';

import {
  ControlTypeEnum,
  DictionariesEnum,
  FieldsEnum,
  FormSectionHeadingType,
  LabelEnum,
  MessagesEnum,
  ScreenEnum,
  SectionsEnum,
  TooltipsEnum,
  MessageTypeEnum,
  TerminationGeneratorEnum,
  ModelPathEnum,
  ControlLabelEnum,
} from 'app/shared/enums';
import { addConsentsToFormConfig } from 'app/shared/helpers/addConsentsToFormConfig';

const baseTerminationGeneratorFormConfig = {
  screens: [
    {
      key: ScreenEnum.TerminationGeneratorScreen1,
      label: '',
      sections: [
        {
          key: SectionsEnum.TerminationGeneratorSelectInsurerSection,
          label: 'Wybierz towarzystwo ubezpieczeniowe',
          subLabel: '',
          questions: [
            {
              key: FieldsEnum.TerminationPreviousInsurerName,
              modelPath: 'previousInsurerName',
              label: TerminationGeneratorEnum.SelectInsurer,
              type: ControlTypeEnum.AutoComplete,
              answersDictionaryKey: DictionariesEnum.CarInsurers,
              onChange: ['onTerminationPreviousInsurerChange'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              labelAboveInputField: true,
              width: 'full',
            },
          ],
          visible: true,
        },
      ],
    },
    {
      key: ScreenEnum.TerminationGeneratorScreen2,
      label: '',
      sections: [
        {
          key: SectionsEnum.TerminationGeneratorSection1,
          label: LabelEnum.VehicleDataSection,
          subLabel: '',
          headingStyle: FormSectionHeadingType.Screen,
          questions: [
            {
              key: FieldsEnum.VehicleType,
              modelPath: 'vehicleType',
              type: ControlTypeEnum.VehicleType,
              label: LabelEnum.Vehicle,
              answersDictionaryKey: DictionariesEnum.VehicleType,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
            },
          ],
          visible: true,
        },
        {
          key: SectionsEnum.TerminationGeneratorSection2,
          label: '',
          subLabel: '',
          questions: [
            {
              key: FieldsEnum.CarProductionYear,
              modelPath: 'car.productionYear',
              label: LabelEnum.SelectProductionYear,
              type: ControlTypeEnum.DateList,
              answersDictionaryKey: DictionariesEnum.CarProductionYears,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'sm',
              vehicleKind: '!MOTOR',
            },
            {
              key: FieldsEnum.CarProductionYear,
              modelPath: 'car.productionYear',
              label: LabelEnum.SelectProductionYear,
              type: ControlTypeEnum.DateList,
              answersDictionaryKey: 'motorcycle_production_years',
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'sm',
              vehicleKind: 'MOTOR',
            },
            {
              key: FieldsEnum.CarMake,
              modelPath: 'car.make',
              label: LabelEnum.Make,
              type: ControlTypeEnum.List,
              answersDictionaryKey: 'car_makes',
              answerGroups: [
                {
                  key: 'car.make.popular',
                  groupName: 'popular',
                  label: LabelEnum.PopularMakes,
                  subLabel: '',
                },
                {
                  key: 'car.make.all',
                  groupName: 'all',
                  label: LabelEnum.AllMakes,
                  subLabel: '',
                },
              ],
              answersDictionaryParams: ['car.productionYear'],
              dependsOn: ['car.productionYear'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              vehicleKind: '!MOTOR',
            },
            {
              key: FieldsEnum.CarMake,
              modelPath: 'car.make',
              label: LabelEnum.Make,
              type: ControlTypeEnum.List,
              answersDictionaryKey: 'motorcycle_makes',
              answerGroups: [
                {
                  key: 'car.make.popular',
                  groupName: 'popular',
                  label: LabelEnum.PopularMakes,
                  subLabel: '',
                },
                {
                  key: 'car.make.all',
                  groupName: 'all',
                  label: LabelEnum.AllMakes,
                  subLabel: '',
                },
              ],
              answersDictionaryParams: ['car.productionYear'],
              dependsOn: ['car.productionYear'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'md',
              vehicleKind: 'MOTOR',
            },
            {
              key: FieldsEnum.CarModel,
              modelPath: 'car.model',
              label: ControlLabelEnum.Model,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarModels,
              answersDictionaryParams: ['car.productionYear', 'car.make'],
              dependsOn: ['car.make'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              vehicleKind: '!MOTOR',
            },
            {
              key: FieldsEnum.CarModel,
              modelPath: 'car.model',
              label: ControlLabelEnum.Model,
              type: ControlTypeEnum.List,
              answersDictionaryKey: 'motorcycle_models',
              answersDictionaryParams: ['car.productionYear', 'car.make'],
              dependsOn: ['car.make'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'md',
              vehicleKind: 'MOTOR',
            },
            {
              key: FieldsEnum.CarFuelType,
              modelPath: 'car.fuelType',
              label: LabelEnum.FuelType,
              type: ControlTypeEnum.List,
              answersDictionaryKey: 'motorcycle_fuel_types',
              answersDictionaryParams: ['car.productionYear', 'car.model'],
              dependsOn: ['car.model'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'md',
              vehicleKind: 'MOTOR',
            },
            {
              key: FieldsEnum.CarEngineCapacity,
              modelPath: 'car.engineCapacity',
              label: LabelEnum.EngineCapacity,
              type: ControlTypeEnum.List,
              answersDictionaryKey: 'engine_capacities',
              answersDictionaryParams: [
                'car.productionYear',
                'car.model',
                'car.fuelType',
              ],
              dependsOn: ['car.fuelType'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'md',
              vehicleKind: 'MOTOR',
            },
            {
              key: 'car.versionEt',
              modelPath: 'car.versionEt',
              label: LabelEnum.DoorsCount,
              type: ControlTypeEnum.List,
              answersDictionaryKey: 'motorcycle_model_versions',
              answersDictionaryParams: [
                'car.productionYear',
                'car.model',
                'car.fuelType',
                'car.engineCapacity',
              ],
              dependsOn: ['car.engineCapacity'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'xl',
              vehicleKind: 'MOTOR',
            },
            {
              key: FieldsEnum.TerminationCarRegistrationNumber,
              modelPath: 'car.registrationNumber',
              label: LabelEnum.VehicleRegistrationNumber,
              type: ControlTypeEnum.CarRegistrationNumber,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
            },
          ],
          visible: true,
        },
        {
          key: SectionsEnum.TerminationGeneratorSection3,
          label: LabelEnum.OwnerDataSection,
          headingStyle: FormSectionHeadingType.Screen,
          subLabel: '',
          questions: [
            {
              key: FieldsEnum.TerminationName,
              modelPath: 'name',
              label: LabelEnum.FirstName,
              type: ControlTypeEnum.Name,
              answersDictionaryKey: 'first-names',
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: false,
              tooltip: TooltipsEnum.TerminationGeneratorOwnerDetailsTooltip,
            },
            {
              key: FieldsEnum.TerminationLastName,
              modelPath: 'lastName',
              label: LabelEnum.LastName,
              type: ControlTypeEnum.LastName,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: false,
            },
          ],
          visible: true,
        },
        {
          key: SectionsEnum.TerminationGeneratorSection4,
          label: LabelEnum.OwnerAddress,
          subLabel: '',
          questions: [
            {
              key: FieldsEnum.TerminationZipCode,
              modelPath: 'zipCode',
              label: LabelEnum.ZipCode,
              type: ControlTypeEnum.ZipCode,
              onChange: ['onTerminationZipCodeChange'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              tooltip: TooltipsEnum.TerminationGeneratorAddressDetailsTooltip,
            },
            {
              key: FieldsEnum.TerminationCity,
              modelPath: 'city',
              label: LabelEnum.City,
              type: ControlTypeEnum.List,
              answersDictionaryKey: 'cities',
              answersDictionaryParams: [
                'zipCode:vehicleOwner.legalAddress.zipCode',
              ],
              dependsOn: [FieldsEnum.TerminationZipCode],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.TerminationStreetName,
              modelPath: 'streetName',
              label: LabelEnum.StreetName,
              type: ControlTypeEnum.StreetName,
              answersDictionaryKey: DictionariesEnum.StreetsByZipCodeAndCity,
              answersDictionaryParams: [
                'zipCode:vehicleOwner.legalAddress.zipCode',
                'city:vehicleOwner.legalAddress.city',
              ],
              dependsOn: [FieldsEnum.TerminationCity],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.TerminationStreetNumber,
              modelPath: 'streetNumber',
              label: LabelEnum.StreetNumber,
              type: ControlTypeEnum.HouseNumber,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.TerminationApartmentNumber,
              modelPath: 'apartmentNumber',
              label: LabelEnum.ApartmentNumber,
              type: ControlTypeEnum.HouseNumber,
              required: false,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.TerminationPhoneNumber,
              modelPath: 'phoneNumber',
              label: LabelEnum.PhoneNumber,
              type: ControlTypeEnum.PhoneNumber,
              required: false,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              tooltip: TooltipsEnum.TerminationGeneratorPhoneNumberTooltip,
            },
          ],
          visible: true,
        },
        {
          key: SectionsEnum.TerminationGeneratorSection5,
          label: LabelEnum.InsurancPolicyDataSection,
          subLabel: '',
          headingStyle: FormSectionHeadingType.Screen,
          questions: [
            {
              key: FieldsEnum.TerminationInsurancePolicyEnding,
              modelPath: 'endDate',
              label: LabelEnum.InsurancePolicyEnding,
              type: ControlTypeEnum.Date,
              onChange: ['onTerminationInsurancePolicyEndingChange'],
              required: true,
              visible: true,
              editable: true,
              startDate: moment(new Date()).format('YYYY-MM-DD'),
              minDate: moment(new Date())
                .subtract(1, 'year')
                .add(1, 'days')
                .format('YYYY-MM-DD'),
              maxDate: moment(new Date()).add(1, 'year').format('YYYY-MM-DD'),
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'sm',
              tooltip: TooltipsEnum.TerminationGeneratorPolicyEndingTooltip,
              disableCenturyView: true,
            },
            {
              key: FieldsEnum.TerminationReason,
              modelPath: 'noticeReason',
              label: LabelEnum.TerminationReason,
              type: ControlTypeEnum.Radio,
              onChange: ['onTerminationReasonChange'],
              answersDictionaryKey: DictionariesEnum.NoticeReason,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'full',
            },
            {
              key: FieldsEnum.TerminationNoticeDate,
              modelPath: 'noticeDate',
              label: TerminationGeneratorEnum.TerminationNoticeDate,
              type: ControlTypeEnum.Date,
              required: true,
              startDate: moment(new Date()).format('YYYY-MM-DD'),
              visible: false,
              editable: true,
              clearOnHide: true,
              width: 'sm',
            },
            {
              key: FieldsEnum.TerminationInsurancePolicyStart,
              modelPath: 'startDate',
              label: LabelEnum.TerminationInsurancePolicyStartDate,
              type: ControlTypeEnum.Date,
              required: true,
              visible: false,
              editable: true,
              minDate: moment(new Date())
                .subtract(1, 'year')
                .add(1, 'days')
                .format('YYYY-MM-DD'),
              startDate: moment(new Date()).format('YYYY-MM-DD'),
              maxDate: moment(new Date()).add(1, 'days').format('YYYY-MM-DD'),
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'sm',
              disableCenturyView: true,
            },
            {
              key: FieldsEnum.TerminationInsurerName,
              modelPath: 'insurerName',
              label: LabelEnum.TerminationNewInsurer,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarInsurers,
              required: true,
              visible: false,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              width: 'full',
            },
            {
              key: FieldsEnum.TerminationPolicyNumber,
              modelPath: 'previousPolicyNumber',
              label: LabelEnum.InsurancePolicyNumber,
              type: ControlTypeEnum.PolicyNumber,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              tooltip: TooltipsEnum.TerminationGeneratorPolicyNumberTooltip,
            },
          ],
          visible: true,
        },
        {
          key: SectionsEnum.TerminationGeneratorSection6,
          label: LabelEnum.SendTermination,
          subLabel: '',
          headingStyle: FormSectionHeadingType.Screen,
          questions: [
            {
              key: FieldsEnum.TerminationEmailAddress,
              modelPath: 'emailAddress',
              label: LabelEnum.TerminationEmailAddress,
              type: ControlTypeEnum.Email,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
              tooltip: TooltipsEnum.TerminationGeneratorEmailTooltip,
              onChange: ['onTerminationEmailChange'],
              messages: [
                {
                  key: MessagesEnum.EnterYourEmailToProceed,
                  type: MessageTypeEnum.Danger,
                  visible: false,
                  content: LabelEnum.EnterYourEmailToProceed,
                },
              ],
            },
          ],
          visible: true,
        },
      ],
    },
  ],
};

export const getTerminationGeneratorFormConfig = () =>
  addConsentsToFormConfig(baseTerminationGeneratorFormConfig, {
    sectionKey: SectionsEnum.TerminationGeneratorConsents,
    regulationsConsentField: FieldsEnum.TerminationConsentRegulations,
    marketingConsentField: FieldsEnum.TerminationConsentMarketing,
    regulationsModelPath: ModelPathEnum.ConsentsRegulationsConsent,
    marketingModelPath: ModelPathEnum.ConsentsMarketingConsent,
    shouldPatch: false,
    clearOnHide: true,
    regulationsRequired: true,
    marketingRequired: false,
  });
